import React from 'react';
import { LANGUAGE_ENUMS } from '../../../../constants/staticPageConstants';
import { FrCommonNavbar } from '../../../Header/FrCommonHeader';
import { AeNavbar } from '../../../Header/aeHeader';
import { DefaultNavBar } from '../../../Header/default';
import { SaNavbar } from '../../../Header/saHeader';
import { checkIfB2CPage } from '../../../Header/utils';
import { InternationalNavBar } from '../../../International/landing-pages/Header';
import { ClearInNavbar } from '../../../Navbar/ClearNavbar';
import { RadCTA } from '../../../Navbar/ClearNavbar/cta';
import { LOGOS } from '../constants';
import { HeaderLanguageDropDown } from '../language/languageTags';
import { HeaderLanguageDropDownAe } from '../language/languageTagsAe';
import { HeaderFrLanguageDropDown } from '../language/multiLangDropDown';
import { CATEGORY_PROPS, THEME } from '../types';

type CMSHeaderProps = {
  domain: number;
  category: CATEGORY_PROPS;
  altLangLink?: string | null;
  isMultiLang?: boolean;
  permalink: string;
  language: LANGUAGE_ENUMS;
  theme?: THEME;
};

export enum NAV_TYPES {
  B2B,
  B2C,
  DEFAULT,
}
export const b2bData = {
  logo: LOGOS.clear,
  rightCTA: <RadCTA />,
  type: NAV_TYPES.B2B,
};

export const b2cData = {
  logo: LOGOS.cleartax,
  rightCTA: null,
  type: NAV_TYPES.B2C,
};
export const defaultData = {
  logo: LOGOS.itrGuide,
  rightCTA: null,
  type: NAV_TYPES.DEFAULT,
};

export const CMSHeader = (props: CMSHeaderProps): JSX.Element => {
  const { domain, category, language, isMultiLang = false, permalink } = props;

  const domainval = domain;
  const isB2CPage = checkIfB2CPage(category.slug);

  const navData = isB2CPage ? b2cData : b2bData;

  const getHeader = () => {
    switch (domainval) {
      case 1: {
        return <ClearInNavbar data={navData} isB2CPage={isB2CPage} />;
      }

      case 2: //cleartax.com/sa
      case 6: //cleartax.com/om
      case 7: //cleartax.com/bh
        return (
          <SaNavbar
            language={language}
            LangSwitchLink={HeaderLanguageDropDown(isMultiLang, permalink)}
            domain={domainval}
          />
        );
      case 8: //cleartax.com/ae
        return (
          <AeNavbar
            language={language}
            LangSwitchLink={HeaderLanguageDropDownAe(isMultiLang, permalink)}
            domain={domainval}
          />
        );

      case 4: //clear.in
        return <ClearInNavbar data={navData} />;

      case 5: //clear.tech
        return <InternationalNavBar theme={THEME.light} />;

      case 9: //cleartax.com/fr
      case 10: //cleartax.com/es
      case 11: //cleartax.com/pl
      case 12: //cleartax.com/my
      case 13: //cleartax.com/sg
      case 14: //cleartax.com/de
      case 15: //cleartax.com/be
      case 16: //cleartax.com/ph
      case 17: //cleartax.com/th
      case 18: //cleartax.com/vi
      case 19: //cleartax.com/id
      case 20: //cleartax.com/eg
      case 21: //cleartax.com/au
      case 22: //cleartax.com/ro
      case 23: //cleartax.com/el
        return (
          <FrCommonNavbar
            domain={domainval}
            language={language}
            LangSwitchLink={HeaderFrLanguageDropDown(
              isMultiLang,
              permalink,
              domainval
            )}
          />
        );

      default:
        return <DefaultNavBar />;
    }
  };
  return <>{getHeader()}</>;
};
